import React, { useMemo, useEffect, useState } from "react";
import PropTypes from "prop-types";
import * as url from "../../helpers/common_helper";

//import components
import Breadcrumbs from "components/Common/Breadcrumb";
import DataTable from "../../components/Common/LocalizedDataTable";
import { BookingApi } from "apis/BookingApi";
import { useHistory, useLocation, Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import config from "config/config";
import { formatNumber } from "../../helpers/language_helper";

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

function AllBooking(props) {
  const query = useQuery();
  const history = useHistory();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeData, setActiveData] = useState({
    page: 1,
    totalPage: 1,
    search: "",
    limit: config.LIMIT,
  });

  useEffect(() => {
    getAllBookings(activeData);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getAllBookings({ ...activeData });
    // eslint-disable-next-line
  }, [query]);

  const columns = [
    {
      name: props.t("Sr.No"),
      selector: row => row.sr_no,
      cell: row => formatNumber(row.sr_no),
      sortable: false,
    },
    {
      name: props.t("Booking ID"),
      selector: row => row.booking_id,
      cell: row => formatNumber(row.booking_id),
      sortable: true,
    },
    { name: props.t("Customer Name"), selector: row => row.customer_name, sortable: true },
    { name: props.t("Salon Name"), selector: row => row.salon_name, sortable: true },
    { name: props.t("Admin Name"), selector: row => row.admin_name, sortable: true },
    { name: props.t("Booking Date"), selector: row => row.booking_date, sortable: true },
    { name: props.t("Action"), selector: row => row.action }
  ];

  const getAllBookings = (dataParams) => {
    setLoading(true);
    BookingApi.getAllBookings({
      page: dataParams.page,
      limit: dataParams.limit,
      search: dataParams.search,
    })
      .then((res) => {
        setActiveData({
          page: dataParams.page,
          totalPage: res.data.data.total,
          search: dataParams.search,
          limit: dataParams.limit,
        });

        let bookings = [];
        res?.data?.data?.bookings?.forEach((v, i) => {
          bookings[i] = {
            sr_no: (dataParams.page - 1) * dataParams.limit + (i + 1),
            booking_id: v.booking_id,
            customer_name: [v.firstname, v.middlename, v.lastname].filter(Boolean).join(" "),
            salon_name: v.salon_name,
            admin_name: [v.salon_admin_firstname, v.salon_admin_middlename, v.salon_admin_lastname].filter(Boolean).join(" "),
            booking_date: v.booking_date,
            action: (
              <button
                className="btn btn-sm btn-link"
                onClick={() => history.push(`/view-booking/${v.booking_id}`)}
              >
                <i className="fas fa-eye" title={props.t("View")} />
              </button>
            ),
          };
        });

        setData(bookings);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const handleChange = (page) => {
    const updatedData = { ...activeData, page };
    setActiveData(updatedData);
    getAllBookings(updatedData);
  };

  const handleRowChange = (limit) => {
    const updatedData = { ...activeData, limit, page: 1 }; // reset page when limit changes
    setActiveData(updatedData);
    getAllBookings(updatedData);
  };

  //meta title
  document.title = props.t("All Bookings") + " | " + props.t("Salon");

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs
          title={props.t("Bookings")}
          breadcrumbItem={props.t("All Bookings")}
        />
      </div>
      <div className="container-fluid">
        <DataTable
          className="table-bordered"
          progressPending={loading}
          columns={columns}
          data={data}
          pagination
          paginationServer
          paginationTotalRows={activeData.totalPage}
          paginationPerPage={activeData.limit}
          onChangeRowsPerPage={handleRowChange}
          onChangePage={handleChange}
          noHeader
          highlightOnHover
        />
      </div>
    </div>
  );
}

AllBooking.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(AllBooking);
